import { render, staticRenderFns } from "./VATabs.vue?vue&type=template&id=47fdef9e&"
import script from "./VATabs.vue?vue&type=script&lang=js&"
export * from "./VATabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports